import { render, staticRenderFns } from "./DoubleColumnLayout.vue?vue&type=template&id=1f9dc13e&"
import script from "./DoubleColumnLayout.vue?vue&type=script&lang=js&"
export * from "./DoubleColumnLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports